import { Component, OnInit } from "@angular/core";
import { NavParams, Platform, ToastController } from "@ionic/angular";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "src/app/components/menu/navigator";
import { RafService } from "src/app/services/raf/raf.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { Clipboard } from "@capacitor/clipboard";

@Component({
  selector: "app-raf-overview",
  templateUrl: "./raf-overview.component.html",
  styleUrls: ["./raf-overview.component.scss"],
})
export class RafOverviewComponent implements OnInit {
  public customer: CustomerModel;
  public code: string = "";
  public invite_count: string = "0";
  public invite_accepted_count: string = "0";
  public invite_total_award_amount: string = "0";
  public copyText: any;

  constructor(
    protected platform: Platform,
    private userSessionService: UserSessionService,
    private toastController: ToastController,
    private navigator: Navigator,
    private rafService: RafService,
    private utils: UtilsService,
    private navParams: NavParams
  ) {
    this.userSessionService.getCustomer().subscribe((customer) => {
      this.customer = customer;

      for (let i: number = 0; i < this.customer.customData.length; i++) {
        if (this.customer.customData[i].key == "invite_count") {
          this.invite_count = this.customer.customData[i].value;
        }

        if (this.customer.customData[i].key == "invite_accepted_count") {
          this.invite_accepted_count = this.customer.customData[i].value;
        }

        if (this.customer.customData[i].key == "invite_total_award_amount") {
          this.invite_total_award_amount = this.customer.customData[i].value;
        }
      }
      this.customer.customData;
    });

    this.rafService.callGetReferrerCode().subscribe(
      (response: any) => {
        // this.logger.log("callGetReferrerCode response = ", response);
        if (response && !!response.result) {
          this.code = response.payload.code;
        }
      },
      (error) => {
        // this.logger.log("callGetReferrerCode error = ", error);
      }
    );
  }

  ngOnInit() {}

  ionViewDidEnter() {
    this.copyText = document.getElementById("codeCopy");
  }

  onCopyCode() {
    let element = this.copyText;
    element.select();
    if (this.platform.is("ios") && !this.platform.is("capacitor")) {
      element.focus();
      element.setSelectionRange(0, 999);
      document.execCommand("Copy");
    } else if (this.platform.is("capacitor")) {
      if (this.platform.is("ios")) {
        element.focus();
        element.setSelectionRange(0, 999);
      }
      Clipboard.write({
        string: element.value,
      }).then(() => {
        console.log("Clipboard Copy Complete!", element.value);
      });
    } else {
      navigator.clipboard.writeText(element.value);
    }
  }

  openPage(page) {
    this.navigator.navigateTo(page, { multipleModals: true });
  }
  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      if (navigateBackPage == "default") {
        this.navigator.dismissAll();
      } else {
        this.navigator.navigateTo(navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };
}
